import React from 'react';

import { Input } from 'antd';

import {Bubble} from '@ant-design/x';
import Config from '../../config/Config';
import Widget from '../../widget/Widget';
import WidgetAjax from '../../widget/WidgetAjax';
import AIChatInput from './AIChatInput';

import './chat.scss'
import WidgetMessage from '../../widget/WidgetMessage';

const sourcePath =  Config.getSourcePath();

const AIIcon = () => {
    return <img style={{heigt:40, width:40}} src={require("./../../img/" + sourcePath +"/ai-chat/ai-user.png")}></img>
}

const ApplicantIcon = () => {
    return <img style={{heigt:40, width:40}} src={require("./../../img/" + sourcePath +"/ai-chat/user.png")}></img>
}

class Chat extends React.Component 
{
    constructor( props )
    {
        super(props);

        this.state = {
            basePath: Config.getBasePath(),
            sourcePath: Config.getSourcePath(),
            sessionId: props.sessionId,
            sessionTitle:props.sessionTitle,
            role:props.role || "ai",
            chatContent: props.chatContent || undefined,
            editing:false,
            roles:{
                ai: { // AI
                    placement: 'start',
                    typing: {
                      step: 5,
                      interval: 20,
                    },
                    styles: {
                      content: {
                        borderRadius: 5,
                        background:'#FFFFFF'
                      },
                    },
                    avatar:{
                        icon:<AIIcon />,
                    }
                },
                applicant: { //求职者
                    placement: 'end',
                    variant: 'shadow',
                    styles: {
                        content: {
                            borderRadius: 5,
                            background:'#E2211C',
                            color:"#FFFFFF"
                        },
                    },
                    avatar:{
                        icon:<ApplicantIcon />,
                    }

                },
                consoler: { // 客服人员
                    placement: 'start',
                    typing: {
                      step: 5,
                      interval: 20,
                    },
                    styles: {
                      content: {
                        borderRadius: 16,
                      },
                    },
                },
                instructor: { // 指导员
                    placement: 'start',
                    typing: {
                      step: 5,
                      interval: 20,
                    },
                    styles: {
                      content: {
                        borderRadius: 16,
                      },
                    },
                }
            }
        }

        this.inputRef = React.createRef();
    }

    componentDidMount() {

        const { sessionId, chatContent } = this.state;

        Widget.loadClass();

        if( sessionId )
        {
            this.loadSessionMessage();
        }
        else if( chatContent )
        {
            this.send();
        }

        
    }

    componentWillUnmount()
    {
        if( this.props.scrollRef && this.props.scrollRef.current ) 
        {
            this.props.scrollRef.current.removeEventListener('scroll', this.handleScroll);
        }
    }

    componentWillReceiveProps( nextProps )
    {   
        let { scene } = this.props;

        if( scene==="resume" )
        {
            if( nextProps.resumeInfo )
            {
                this.addTipChat(nextProps.resumeInfo);
            }
        }
    }

    componentDidUpdate() 
    {
        this.handleScroll();
    }

    handleScroll = () => {

        if( this.props.scrollRef && this.props.scrollRef.current ) 
        {
            this.props.scrollRef.current.scrollTo({
                top: this.props.scrollRef.current.scrollHeight,
                behavior: 'smooth' // 平滑滚动效果
            });
        }
    }

    /**
     * 创建会话
     */
    createSession = ( callback ) => {

        const { scene } = this.props;

        const { basePath } = this.state;

        let params = {
            scene: scene || "resume",
            title: "新对话",
            type: "02"
        }

        const onCreateSession = (result, backParams) => {

            if( result.status===0 )
            {
                this.setState({sessionId:result.result}, () => {

                    if( callback )
                    {
                        callback()
                    }
                });
            }
        }

        WidgetAjax.ajax({url: basePath + "/session/create", params:params, callback:onCreateSession}, this.props);
    }

    /**
     * 加载会话消息
     */
    loadSessionMessage = ( ) => {

        const { basePath, sessionId } = this.state;

        let params = {
            session_id: sessionId,
            page:1,
            records: 20
        }

        const onLoadSessionMessage = (result, backParams) => {

            if( result.status===0 )
            {
                if( result.results.length>0 )
                {
                   
                    this.buildSessionMessage(result.results);
                }
            }
        }

        WidgetAjax.ajax({url: basePath + "/session/message", params:params, callback:onLoadSessionMessage}, this.props);
    }

    addTipChat = ( resumeInfo ) => {

        if( resumeInfo.RIC>=0.7 )
        {
            let { items=[] } = this.state;

            items.push({
                key: Widget.randomString(12),
                loading:false,
                role:"ai",
                content: "<span class='sf-chat-resume-tip'>您的简历已经填写<span class='sf-chat-resume-ric'>" + resumeInfo.RIC*100 + "%</span>，可以在右侧查看简历信息和修改！</span>"
            })

            this.setState({items:items});
        }
    }

    buildSessionMessage = (sessionMessage=[] ) => {

        let items = [], history=[];

        sessionMessage.reverse();

        let i = 1, historyGroup = []

        for( let messageItem of sessionMessage )
        {
            
            if( i==2  )
            {
                historyGroup.push(messageItem.message);

                history.push([...historyGroup]);

                historyGroup = [];

                i = 1;
            }
            else
            {
                historyGroup.push(messageItem.message);

                i++;
            }

            if( messageItem.source==="1" || messageItem.source===1)
            {
                items.push({
                    key:messageItem.id,
                    loading:false,
                    role:"applicant",
                    content: messageItem.message
                });
            }
            else if(  messageItem.source==="2" || messageItem.source===2 )
            {
                items.push({
                    key:messageItem.id,
                    loading:false,
                    role:"ai",
                    content: messageItem.message
                });
            }
            else if(  messageItem.source==="3" || messageItem.source===3 )
            {
                items.push({
                    key:messageItem.id,
                    loading:false,
                    role:"consoler",
                    content: messageItem.message
                });
            }
            else if(  messageItem.source==="4" || messageItem.source===4 )
            {
                items.push({
                    key:messageItem.id,
                    loading:false,
                    role:"instructor",
                    content: messageItem.message
                });
            }
        }

        this.setState({items:items, historyItems:[...items], history:history});
    }

    send = () => {

        let {items=[], role, chatContent} = this.state;

        if( chatContent && chatContent.replace("\n", "")!=="" && chatContent.replace(/\s/g, "")!=="" )
        {
            items.push({
                key:Widget.randomString(12),
                loading:false,
                role:"applicant",
                content: chatContent
            });
    
            items.push({
                key:Widget.randomString(12),
                loading:true,
                role:role,
                content: "思考中，请稍后"
            });
    
            this.setState({items:items},  () => {
                this.sessionChat();
                this.handleScroll();
            })
        }
    }

    /**
     * 发送会话消息
     */
    sessionChat = () => {

        const { scene } = this.props;

        const { sessionId, history=[], chatContent, items, role } = this.state;

        let historyGroup = [];

        if( sessionId )
        {
            const { basePath } = this.state;

            let params = {
                session_id: sessionId,
                history: history,
                message: chatContent
            }

            historyGroup.push(chatContent);


            const onSessionChat = (result, backParams) => {

                if( result.status===0 )
                {
                    items.pop();

                    items.push({
                        key:result.result.id,
                        loading:false,
                        role:role,
                        content: result.result.reply
                    })

                    historyGroup.push(result.result.reply);

                    history.push([...historyGroup]);

                    this.setState({items:items, history:history});

                    if( scene==="resume" )
                    {
                        if( this.props.notify )
                        {
                            this.props.notify("update-resume")
                        }
                    }
                }
            }

            WidgetAjax.ajax({url: basePath + "/session/chat", params:params, callback:onSessionChat}, this.props);
        }
        else
        {
            // 没有会话id, 优先创建会话
            this.createSession( this.sesssionChat );
        }

    }

    buildRoles = () => {

        let { roles } = this.state;
    }


    AIChatInputNotify = ( e, type) => {

        switch( type )
        {
            case "onChange":
            {
                this.setState({chatContent: e.target.value});
                break;
            }
            case "send":
            case "onKeyUp":
            {
                this.send();
                break;
            }
            case "link":
            {
                this.link();
                break;
            }
        }
    }

    createNewSession = () => {
        if( this.props.notify )
        {
            this.props.notify(null, "new-session")
        }
    }

    /**
     * 输入框内容变化回调
     * @param {*} e 
     */
    onInputChange = ( e ) => {

        this.setState({sessionTitle:e.target.value});
    }
    

    titleEdit = () => {

        this.setState({editing:true})
    }

    updateTitle = () => {

        const { basePath, sessionTitle,  sessionId } = this.state;

        this.setState({editing:false});

        let params = {
            id: sessionId,
            title: sessionTitle
        }

        const onUpdateTitle = (result, backParams) => {

            if( result.status===0 )
            {
            }
        }

        WidgetAjax.ajax({url: basePath + "/session/update", params:params, callback:onUpdateTitle}, this.props);
    }

    messageRender = ( content ) => {

        content = content.replace(/\\n/g, "<br/>");

        return  <div dangerouslySetInnerHTML={{ __html: content }} />
    }

    render()
    {
        const {items=[], roles, sourcePath, sessionTitle,  editing = false} = this.state;

        return (
            <div className="sf-chat-body">
                <div className="sf-chat-title">
                {
                    editing ? 
                    <>
                        <div onMouseLeave={this.updateTitle} >
                            <Input value={sessionTitle} style={{width:200, height:30}} 
                                ref={this.inputRef} 
                                onChange={this.onInputChange} 
                                onPressEnter={this.updateTitle} 
                                onBlur={this.updateTitle} />
                        </div>
                    </>
                    :<div className="sf-chart-title-body" onMouseOver={this.titleEdit} >
                        {sessionTitle}
                    </div>
                }
                </div>
                <div  className="sf-chat-content">
                    <Bubble.List
                        key={JSON.stringify(items)}
                        // items={items}
                        roles={roles}
                        items = { items.map( (item, index) => {

                            let content = item.content;

                            if( content.startsWith("\n\n") )
                            {
                                content = content.substring("\n\n".length);
                            }
                            content = content
                            // 转换 ### **数字. 标题** 为 div
                            .replace(/### \*\*(\d+\..+?)\*\*\n/g, '<div class="sf-chat-content-title">$1</div>')
                            .replace(/### \*\*(.+?)\*\*\n/g, '<div class="sf-chat-content-title">$1</div>')
                            // 转换 - **字段名** 为 strong
                            .replace(/- \*\*(.+?)\*\*：/g, '<span class="sf-chat-content-sub-title">$1</span>：')
                            .replace(/\*\*(.+?)\*\*：/g, '<span class="sf-chat-content-sub-title">$1</span>：');

                            content = content.replace(/\n\n---\n\n/g, "<br/>")
                            // 保留换行符
                            .replace(/\n/g, '<br/>');


                            // content = content.replace(/\n\n---\n\n/g, "<br/><br/>");
                            // content = content.replace(/\n/g, "<br/>");
                            // content = content.replace(/^- \*\*(.+?)\*\*$/gm, '<div className="sf-chat-content-sub-title">$1</div>');

                            content = <div dangerouslySetInnerHTML={{ __html: content }} />;
                            return {...item, content:content};
                        }) }
                        // className={styles.messages}
                    />
                </div>


                <div className="sf-chat-footer">
                    <div className="sf-chat-session-new-container" onClick={this.createNewSession}>
                        <div className="sf-chat-session-new">
                            <img src={require("./../../img/" + sourcePath +"/ai-chat/new-session.png")}></img>
                            <span className="sf-chat-session-new-font">开启新对话</span>
                        </div>
                       
                    </div>

                    <div className="sf-chat-send">
                        <AIChatInput notify={this.AIChatInputNotify} ></AIChatInput>
                    </div>

                    <div className="sf-chat-send">
                        <span className="sf-chat-footer-font">内容由AI大模型生成，请仔细甄别</span>
                    </div>
                </div>
                
               
            </div>
        )
    }
}
export default Chat